var map = {
  "./km.json": [
    "615112",
    "525177"
  ],
  "./ru.json": [
    "956155",
    "659134"
  ],
  "./bg.json": [
    "48188",
    "287961"
  ],
  "./el.json": [
    "780889",
    "797077"
  ],
  "./en-pt.json": [
    "6139",
    "406913"
  ],
  "./ja.json": [
    "476178",
    "613834"
  ],
  "./ar.json": [
    "823364",
    "339379"
  ],
  "./rw.json": [
    "356560",
    "835107"
  ],
  "./sr.json": [
    "956085",
    "754041"
  ],
  "./lol.json": [
    "656626",
    "682967"
  ],
  "./fr.json": [
    "864554",
    "445014"
  ],
  "./sv.json": [
    "39314",
    "981778"
  ],
  "./as.json": [
    "949458",
    "467727"
  ],
  "./gu.json": [
    "402398",
    "36639"
  ],
  "./kk.json": [
    "682990",
    "628159"
  ],
  "./nb.json": [
    "298418",
    "34078"
  ],
  "./ta.json": [
    "940488",
    "499145"
  ],
  "./ky.json": [
    "563103",
    "544090"
  ],
  "./pl.json": [
    "380529",
    "472329"
  ],
  "./ro.json": [
    "300360",
    "299913"
  ],
  "./ka.json": [
    "434642",
    "193934"
  ],
  "./hu.json": [
    "960358",
    "680791"
  ],
  "./uk.json": [
    "589983",
    "462161"
  ],
  "./or.json": [
    "232115",
    "326849"
  ],
  "./uz.json": [
    "277263",
    "127274"
  ],
  "./hy.json": [
    "996371",
    "373095"
  ],
  "./de.json": [
    "112820",
    "873720"
  ],
  "./pt-pt.json": [
    "979196",
    "314089"
  ],
  "./vi.json": [
    "470606",
    "199938"
  ],
  "./tr.json": [
    "521964",
    "537070"
  ],
  "./da.json": [
    "787081",
    "935378"
  ],
  "./kn.json": [
    "390416",
    "77865"
  ],
  "./mr.json": [
    "548861",
    "189451"
  ],
  "./id.json": [
    "335917",
    "657780"
  ],
  "./lt.json": [
    "694324",
    "387781"
  ],
  "./lv.json": [
    "706835",
    "726480"
  ],
  "./zh-hans.json": [
    "48817",
    "346814"
  ],
  "./es.json": [
    "254999",
    "11234"
  ],
  "./ko.json": [
    "414969",
    "746683"
  ],
  "./te.json": [
    "927239",
    "565559"
  ],
  "./bn.json": [
    "501641",
    "608200"
  ],
  "./cs.json": [
    "962230",
    "867224"
  ],
  "./boxes.json": [
    "44265",
    "437286"
  ],
  "./my.json": [
    "407312",
    "305525"
  ],
  "./mn.json": [
    "188121",
    "464146"
  ],
  "./sk.json": [
    "870398",
    "379743"
  ],
  "./nl.json": [
    "217881",
    "468126"
  ],
  "./az.json": [
    "608849",
    "783415"
  ],
  "./accents.json": [
    "227585",
    "292707"
  ],
  "./pa.json": [
    "141353",
    "203265"
  ],
  "./pt.json": [
    "671476",
    "612317"
  ],
  "./extra.json": [
    "86084",
    "285609"
  ],
  "./it.json": [
    "739267",
    "425666"
  ],
  "./hi.json": [
    "760376",
    "575925"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 493187;
module.exports = webpackAsyncContext;
